import { useRef, useEffect, useState , Fragment} from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

import Select from 'react-select';
import * as moment from 'moment';
import Clientes from './Clientes';
import Articulos from './Articulos';
import { VentasLineas } from './VentaLineas';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

//import styles 👇
import 'react-modern-drawer/dist/index.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMediaQuery } from 'react-responsive';

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 1,
    nombreCliente: "",
    direccionEnvia: "",
    rnc: "",
    tipoComprobante: "1",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0,
    totalPago: 0.00,moneda: "RD"
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    codigoAuxiliar: "",
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    precioSinITBIS: 0.00,
    ItbisIncluido: false,
    itbis: 0.00,
    descuento: 0.00,
    totalLinea: 0.00,
    fecha: new Date,
    editando: false,
    formaPago: "", 
}


const modeloDatos1F = {

    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    noFactura: "",
    clienteID: 0,
    nombreCliente: "Cliente Miscelaneo",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    telefono: "",
    fecha: new Date,
    comentario: "",
    facturado: false,
    estatus: 0,
    credito:0.00,
    efectivo: 0.00,
    tarjeta: 0.00,
    transferencia: 0.00,
    cheque: 0.00,
    totalPago: 0.00,
    devolucion: 0.00,
    creadoPor: "",
    fechaCreado: new Date,
    moneda: "RD",


}


let options = [];
let options1 = [];
let options2 = [];
let Lineas = [];
let SubTotal = 0;
let TotalDescuento = 0;
let TotalITBIS = 0;
let Total = 0;
let Pago = 0;
let migrado;
let salir = 1;


function SearchableSelect({ options }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOption, setSelectedOption] = useState('');

    // Filtrar opciones basado en el término de búsqueda
    const filteredOptions = options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
            >
                {filteredOptions.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default function Venta({ data, onData })  {
    migrado = data;

    const inputRef = useRef(null);

    const [user, setUser] = useState([window.localStorage.getItem("sesion_usuario")])
    const [interativo, Setinterativo] = useState(false);
    const [modalEditPedido, SetmodalEditPedido] = useState(false);
    const [contador, setContador] = useState(0);

    const [tabla, setTabla] = useState(modeloDatos);
    const [tabla1, setTabla1] = useState(modeloDatos1);
    const [Listado, SetListado] = useState([]);
    const [ListadoCotizacion, setListadoCotizacion] = useState([]);
    const [ListadoNumeroUnico, SetListadoNumeroUnico] = useState([]);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [ListadoArticulo, SetListadoArticulo] = useState([]);
    const [ListadoArticuloB, SetListadoArticuloB] = useState([]);
    const [SN, SetSN] = useState([]);
    const [ListadoClientes, SetListadoClientes] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModalPago, setVerModalPago] = useState(false);
    const [apagarpago, setapagarpago] = useState(false);

    const [verModal, setVerModal] = useState(false);
    const [verModalCliente, setVerModalCliente] = useState(false);
    const [verModalArticulos, setVerModalArticulos] = useState(false);
    const [verModalEditLinea, setverModalEditLinea] = useState(false);
    const [V_Procesar, setV_Procesar] = useState(false);
    const [EditLinea, setEditLinea] = useState(false);
    const [SeleccionCliente, setSeleccionCliente] = useState(false);
    const [busqueda, setbusqueda] = useState("");
    const [Empresa, setEmpresa] = useState();
    const [ListadoDisponible, SetListadoDisponible] = useState([]);

    //const [tabla, setTabla] = useState(modeloDatos);
    const [tabla2, setTabla2] = useState(modeloDatos1F);

    const isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
        obtenerDatosArticulas("****");
    }, [])

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
      
        var searchData = l.filter((item) => {
            if (
                (item.nombreCliente + item.pedidoID )
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };
    let use = JSON.parse(user);


    const handleChange = (e) => {

        

        if (e.target.name == "nombreCliente" ) {
          
        }
        if (e.target.name == "rnc" && e.target.value.length > 8) {
            ValidarRNC(e.target.value);
        }
        if (e.target.name == "tipoComprobante") {

            var vsn = SN.filter(x => x.secuenciaID == e.target.value).map(x => { return x.maximo -x.siguiente   });
            
            if (vsn[0] < 0) {
                alert("Quedan:"+vsn)
            } else {
                setTabla({
                    ...tabla,
                    [e.target.name]: e.target.value
                })
            }
            

        } else { 
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })}
    }

    const handleChangeP = (e) => {
        e.target.value = parseFloat(e.target.value)
        setTabla2({
            ...tabla2,
            [e.target.name]: e.target.value, ["formaPago"]: e.target.name
        })
    }


    const ValidarRNC = async (x) => {
        let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, nombreCliente: (data1).descripcion, rnc: x
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x
                })
            }
        }
    }

   
        const handleChange2 = (e) => {
            setTabla({
                ...tabla,
                ["clienteID"]: e.value, ["nombreCliente"]: e.nombre, ["rnc"]: e.rnc, ["telefono"]: e.telefono, ["direccionEnvia"]: e.direccion
            })
    }

    const handleChange4 = (e) => {
        var itb = 0.00;
        var PrecioSinITBIS = 0.00;
        var total = 0.00;
        if (e.target.name == "descripcionArticulo") {
            setTabla1({
                ...tabla1,
                ["descripcionArticulo"]: e.target.value
            })
        }

            if (e.target.name == "precio") {
            if (Empresa.itbisIncluido) {

                PrecioSinITBIS = (e.target.value) / 1.18;
                itb = (e.target.value) - PrecioSinITBIS;
                total = PrecioSinITBIS + itb;
            } else {

                itb = ((e.target.value) * 0.18);
                total = (e.target.value) + itb;
                PrecioSinITBIS = e.precio;
            }
            setTabla1({
                ...tabla1,
                ["precio"]: e.target.value, ["itbis"]: itb,
                ["precioSinITBIS"]: PrecioSinITBIS,
                ["totalLinea"]: total
            })

        }
    }
   
    const handleChange3 = (e) => {
      
        

        var itb = 0.00;
        var PrecioSinITBIS = 0.00;
        var total = 0.00;
       
        if (e.itbisIncluido) {

             PrecioSinITBIS = (e.precio) / 1.18;
            itb = (e.precio) - PrecioSinITBIS;
             total = PrecioSinITBIS + itb;
        } else {
            // el itb si se sumara se cambio para que esto excluye el impuesto y salga en blanco itbs
          //  itb = ((e.precio) * 0.18);
           // total = (e.precio) + itb;
         //   PrecioSinITBIS = e.precio;
            itb = 0
         total = e.precio
          PrecioSinITBIS = e.precio;
        }
        setTabla1({...tabla1,
            pedidoLineaID:0, empresaID:1,pedidoID: tabla.pedidoID, numeroUnico: tabla.numeroUnico,
           orden:1 , articuloID: e.value, descripcionArticulo: e.nombre, almacenID: e.almacenID,
            cantidad: 1, costo: e.costo, precio: e.precio, itbis: itb,
            descuento: 0.00, precioSinITBIS: PrecioSinITBIS, itbisIncluidoP: e.itbisIncluido,
            totalLinea: total, fecha:new Date , codigoAuxiliar: e.codigoAuxiliar
        })
        tabla1.empresaID = use.empresaID
        tabla1.numeroUnico = tabla.numeroUnico;
            tabla1.orden = "1";
                tabla1.articuloID = e.value;
                    tabla1.descripcionArticulo = e.nombre;
                        tabla1.almacenID = e.almacenID;
                            tabla1.cantidad = 1;
                                tabla1.costo = e.costo;
                                    tabla1.precio = e.precio;
                                        tabla1.itbis = itb;
                                            tabla1.descuento = 0.00;
                                                tabla1.precioSinITBIS = PrecioSinITBIS;
                                                    tabla1.itbisIncluidoP = e.itbisIncluido;
                                                        tabla1.totalLinea = total;
                                                            tabla1.fecha = (new Date);
                                                                tabla1.codigoAuxiliar = e.codigoAuxiliar;

        guardarCambios();
       // GuardarLinea(tabla.pedidoID);
    }
      
         // GuardarLinea()  
    const GuardarLinea = async (e) => {
        tabla1.pedidoID = e;
        tabla1.empresaID = use.empresaID
        if (tabla1.pedidoID != 0) {
        let response = await  fetch(Api + "VentasTrans/GuardarPedidoVentasLineas", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(tabla1)
        })
        if (response.ok) {
            obtenerDatosLineas(e);
            MensajeG("" + tabla1.descripcionArticulo + " Agregado")
            toast.success("Agregado")
            }
         }
    }

    const obtenerDisponible = async () => {
        let response = await fetch(Api + "VentasMantenimiento/ListaDisponible/"+use.empresaID);

        if (response.ok) {
            let data = await response.json()
            SetListadoDisponible(data)

        }
    }


    const EditarLinea1 = async (x, valor, campo, sl) => {
        setV_Procesar(true)
        if (campo == 'editando') { x.editando = valor; }
        if (campo == 'descripcion') { x.descripcionArticulo = valor; }
        if (campo == 'cantidad') {
            if (valor == '') { x.cantidad = 0; } else { x.cantidad = parseFloat(valor); }
        } if (campo == 'precio') {
            if (valor == '') {valor = 0 }
            valor = parseFloat(valor);
            if (valor == '') { x.precio = 0 } else { x.precio = valor; }
        }
        if (campo == 'descuento') {
            valor = parseFloat(valor);
            if (valor == '')
            { x.descuento = 0 }
            else { x.descuento = valor; }

        }
        if (Empresa.itbisIncluido) {
            var itb = 0.00;
            var p = x.precio - x.descuento;
            p = p * parseFloat(x.cantidad)
            var PrecioSinITBIS = ((p) / 1.18) / parseFloat(x.cantidad);
            itb = (p / parseFloat(x.cantidad)) - PrecioSinITBIS;
            var total = (PrecioSinITBIS + itb) * x.cantidad;
            x.precioSinITBIS = PrecioSinITBIS;
        } else {
            var p = x.precio - x.descuento;
            p = p * parseFloat(x.cantidad)
            var itb = 0.00;
            itb = (parseFloat(p) * 0.18) / parseFloat(x.cantidad);
            x.precioSinITBIS = parseFloat(p) / parseFloat(x.cantidad);
            var total = (parseFloat(p) + (parseFloat(itb)) * parseFloat(x.cantidad));
        }
        x.itbis = itb;
        x.totalLinea = total;

        SetListadoLineas(ListadoLineas.map(p => p.pedidoLineaID === sl ? {
            ...p, x   } : p));
   
    }

    //Editar lineas
    const EditarLinea = async (x, valor, campo, sl) => {
        setV_Procesar(false)
        //if (campo == 'descripcion') { x.descripcionArticulo = valor; }
        //if (campo == 'cantidad') {
        //    if (valor == '') { x.cantidad = 1; } else { x.cantidad = valor; } }
        //if (campo == 'precio') {
        //    if (valor == '') { x.precio = 0 }else { x.precio = valor; } }
        //if (campo == 'descuento') {
        //    if (valor == '') { x.descuento = 0 } else { x.descuento = valor; }

        //}
        //if (Empresa.itbisIncluido) {
        //    var itb = 0.00;
        //    var p = x.precio - x.descuento;
        //    p = p * parseFloat( x.cantidad)
        //    var PrecioSinITBIS = ((p) / 1.18) / parseFloat(x.cantidad);
        //    itb = (p / parseFloat(x.cantidad)) - PrecioSinITBIS;
        //    var total = PrecioSinITBIS + itb;
        //    x.precioSinITBIS = PrecioSinITBIS;
        //} else {
        //    var p = x.precio - x.descuento;
        //    p = p * parseFloat(x.cantidad)
        //    var itb = 0.00;
        //    itb = (parseFloat(p) * 0.18) / parseFloat(x.cantidad);
        //    x.precioSinITBIS = parseFloat(p) / parseFloat(x.cantidad);
        //    var total = parseFloat(p) + (parseFloat(itb) * parseFloat(x.cantidad));
        //}
        //x.itbis = itb;
        //x.totalLinea = total;
        x.editando = valor;
        SetListadoLineas(ListadoLineas.map(p => p.pedidoLineaID === sl ? {
            ...p, x
        } : p));

        let response = await fetch(Api + "VentasTrans/EditarPedidoVentasLineas", {
            method: 'put',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(x)
        })
        if (response.ok) {
            setEditLinea(false)
            obtenerDatosLineas(tabla.pedidoID);

          

            toast.success("Agregado")
        }
    }
    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "VentasTrans/listaPedidoVentas/"+use.empresaID);
        if (response.ok) {
            let data = await response.json();
   //         let data = data1.filter(x => x.estatus < 1).map(x => x);
            SetListado1(data)
            if (e == 1) {
                setPendiente(true)
                SetListado(data)
            }

            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
        }
    }

    const obtenerDatosCotizacion = async (e) => {
        let response = await fetch(Api + "VentasTrans/listaPedidoVentasCotizacion/"+use.empresaID);
        if (response.ok) {
            let data = await response.json();
            //         let data = data1.filter(x => x.estatus < 1).map(x => x);
            setListadoCotizacion(data)
            if (e == 1) {
              //  setPendiente(true)
             //   SetListado(data)
            }

            if (pendiente) {
             //   SetListado(data)
             //   setPendiente(false)
            }
        }
    }
    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/ListaSecuenciaNumerica/" + use.empresaID);
        if (response.ok) {
            let data = await response.json();
            SetSN(data.filter(x => x.esncf == 1).map(z => z))
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/"+use.empresaID);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == use.empresaID).map(e =>e)[0]
            setEmpresa(d)
        }
    }

    /// mandar venta a caja para pago
    const EnviarCaja = async (p) => {
        Swal.fire({
            title: 'Enviar a Caja',
            text: "Estas seguro de que desea enviar a caja. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
                let response =  fetch(Api + "VentasTrans/EnviarCaja/" + p);
                if (response.ok) {
                    let data =  response.json()
                    obtenerDatos(1);
                }

                setVerModal(false);
                setPendiente(false);
               

            }
        })
     
    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineas/"+pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)
            SubTotal = data.reduce((x, y) => {
                if (Empresa.itbisIncluido == 0 && tabla.tipoComprobante == 1) {
                return x + (y.precioSinITBIS * y.cantidad) + y.itbis
            } else { return x + ( y.precioSinITBIS * y.cantidad) }
            }, 0);
            TotalDescuento = data.reduce((x, y) => {
                return x + (y.descuento * y.cantidad);
            }, 0);
            TotalITBIS = data.reduce((x, y) => {
                if (Empresa.itbisIncluido == 0 && tabla.tipoComprobante == 1) { return x } else {
                    return x + (y.itbis * y.cantidad);
                }
            }, 0);
            Total = SubTotal  + TotalITBIS;
        }
    }

    const NumeroUnico = async () => {
        let response = await fetch(Api + "VentasMantenimiento/NumeroUnico");
        if (response.ok) {
            let data = await response.json()
            
            SetListadoNumeroUnico(data.filter(x => x.Pantalla =="Facturacion" && x.ID==1).map(x => x))
        }
    }


    const obtenerDatosArticulas = async (e) => {
        options1 = [];
        let response = await fetch(Api + "VentasMantenimiento/listaArticulosV/"+e);
        // options1=[];
        if (response.ok) {
            let data = await response.json()
      //      SetListado1(data)


        //    SetListadoArticulos(data)
            options1 = [];
            data.filter(x => x.activo == true && x.empresaID == use.empresaID).map(x => {
                options1.push({
                    value: x.articuloID, label: x.codigoAuxiliar + "-" + x.descripcion + "      -||              $"+x.precioPromedio, nombre: x.descripcion,
                    almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                    , cambiarPrecio: x.cambiarPrecio, itbisIncluido: x.itbisIncluido, codigoAuxiliar: x.codigoAuxiliar, tipoArticulo: x.tipoArticulo
                })
            })
            if (pendiente) {
                SetListadoArticuloB(options1)
                setPendiente(false)
            }
            SetListadoArticulo(options1);
        }
    }

    const obtenerDatosClientes = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");
        options = [];
        if (response.ok) {
            let data = await response.json()
            SetListadoClientes(data)
            data.filter(x => x.empresaID == use.empresaID).map(x => {
                options.push({ value: x.clienteID, label: x.rnc + "-" + x.descripcion, nombre: x.descripcion, rnc:x.rnc , telefono: x.telefono, direccion:x.direccion})
            })
            tabla.clienteID = 1;
        }
    }


    useEffect(() => {
        obtenerDatos();
        NumeroUnico();
        obtenerDatosSN();
        obtenerDatosEmpresa()
        obtenerDatosClientes()
        obtenerDatosArticulas();
        obtenerDatosCotizacion();
    }, [])
    useEffect(() => {
        obtenerDisponible()
        const intervalo = setInterval(() => {
            setContador((prev) => prev + 1);
        }, 60000); // cada 2 segundos

        // Limpieza del intervalo cuando el componente se desmonta
        return () => clearInterval(intervalo); 
    }, [contador]);


    //Guardar factura
    const guardarCambios = async () => {
        SetmodalEditPedido(false)
        setInputValue("")
        if (tabla.pedidoID == 0 || modalEditPedido == true) {
            let response;
            tabla.empresaID = use.empresaID;
            if (tabla.pedidoID == 0) {

                response = await fetch(Api + "VentasTrans/GuardarPedidoVentas", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })

            } else {
                response = await fetch(Api + "VentasTrans/EditarPedidoVentas", {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })
            }

            if (response.ok) {
                let data = await response.json()
                setTabla(data);
                setPendiente(true)
                obtenerDatos();

                obtenerDatosLineas(data.pedidoID);

                obtenerDatos()
                GuardarLinea(data.pedidoID)
                inputRef.current.focus();
                SetmodalEditPedido(false)
           
            } else {
                alert("error al guardar")
            }
        } else {
            GuardarLinea(tabla.pedidoID)
            tabla1.articuloID = ""
        }
    }
    //Quitar lienas
    const quitarArticulo = async (id) => {
        let response = await fetch(Api + "VentasTrans/QuitarArticulo/" + id, { method: "DELETE" })
        if (response.ok) {
            toast.success("Proceso realizado")
            setPendiente(true)
            obtenerDatosLineas(tabla.pedidoID);
        }
    }


    //sumar secuencia numerica
    const Nuevo = async () => {
        let response = await fetch(Api + "VentasMantenimiento/SumNumeroUnico/1/Facturacion");
        if (response.ok) {
            let data = await response.json()
           tabla.numeroUnico = data;
            setVerModal(!verModal)
             setTabla(modeloDatos);
          setTabla1(modeloDatos1);
        }
        obtenerDatosArticulas();
        obtenerDatosClientes()
      
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
        setverModalEditLinea(!verModalEditLinea)
        obtenerDatosLineas(data.pedidoID);
    }
    const cerrarModal = ()  => {
        if (migrado != null ) {
            onData(false);
        }
        obtenerDatos();
        setTabla(modeloDatos);
        SetListadoLineas([]);
        setTabla1(modeloDatos1);
  setVerModal(false)
      
    }


    //Proceso de pago factura
    const ProcesarPago = async () => {
        setapagarpago(true)
        var procesar = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
        if (procesar >= -0) {
            tabla2.pedidoID = tabla.pedidoID;
            tabla2.empresaID = tabla.empresaID;
            tabla2.estatus = 1;
            tabla2.clienteID = tabla.clienteID;
            tabla2.nombreCliente = tabla.nombreCliente;
            tabla2.ncf = tabla.ncf;
            tabla2.numeroUnico = tabla.numeroUnico;
            tabla2.rnc = tabla.rnc;
            tabla2.telefono = tabla.telefono;
            tabla2.tipoComprobante = tabla.tipoComprobante
            tabla2.moneda = tabla.moneda
            tabla2.comentario = tabla.comentario;
            tabla2.SubTotal = SubTotal;
            tabla2.TotalDescuento = TotalDescuento;
            tabla2.TotalITBIS = TotalITBIS;
            tabla2.totalPago = Total;
            tabla2.credito = parseFloat(tabla2.credito);
            tabla2.efectivo = parseFloat(tabla2.efectivo);
            tabla2.tarjeta = parseFloat(tabla2.tarjeta);
            tabla2.cheque = parseFloat(tabla2.cheque);
            tabla2.transferencia = parseFloat(tabla2.transferencia);
            tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
                parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
                + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
            tabla2.creadoPor = use.correo;
            

            let response = await fetch(Api + "VentasTrans/ProcesarFactura", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla2)
            })
            if (response.ok) {

                Swal.fire(
                    'Guardado!',
                    '',
                    'success'
                )
                
                setPendiente(false)
                setTabla2(modeloDatos1F)
                setVerModalPago(false);
                setVerModal(false);
                setTabla(modeloDatos);
                SetListadoLineas([]);
                obtenerDatos(1);
                window.open("/ImpresionFactura/" + tabla.pedidoID, '_blank');
                if (migrado != null) {
                    onData(false);
                }
            }
        } else {
            Swal.fire(
                'No se puede procesar el pago!',
                'Favor revisar la distribución del pago. Restan:' +procesar,
                'warning'
            )
        }
        setapagarpago(false)
    }
      //Proceso de Cotizacion
    const ProcesarCotizacion = async () => {
        var procesar = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
        if (procesar <= 0) {
            tabla2.pedidoID = tabla.pedidoID;
            tabla2.empresaID = tabla.empresaID;
            tabla2.estatus = 1;
            tabla2.clienteID = tabla.clienteID;
            tabla2.nombreCliente = tabla.nombreCliente;
            tabla2.ncf = tabla.ncf;
            tabla2.numeroUnico = tabla.numeroUnico;
            tabla2.rnc = tabla.rnc;
            tabla2.telefono = tabla.telefono;
            tabla2.tipoComprobante = "3"
            tabla2.comentario = tabla.comentario;
            tabla2.SubTotal = SubTotal;
            tabla2.TotalDescuento = TotalDescuento;
            tabla2.TotalITBIS = TotalITBIS;
            tabla2.totalPago = Total;
            tabla2.credito = parseFloat(tabla2.credito);
            tabla2.efectivo = parseFloat(tabla2.efectivo);
            tabla2.tarjeta = parseFloat(tabla2.tarjeta);
            tabla2.cheque = parseFloat(tabla2.cheque);
            tabla2.transferencia = parseFloat(tabla2.transferencia);
            tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
                parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
                + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
            tabla2.creadoPor = user.correo;

            let response = await fetch(Api + "VentasTrans/ProcesarCotizacion", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla2)
            })
            if (response.ok) {

                setPendiente(false)
                setTabla2(modeloDatos1F)
                setVerModalPago(false);
                setVerModal(false);
                setTabla(modeloDatos);
                SetListadoLineas([]);
                obtenerDatos(1);
                window.open("/ImpresionCotizacion/" + tabla.pedidoID, '_blank');
              
                Swal.fire(
                    'Guardado!',
                    '',
                    'success'
                )
                obtenerDatosCotizacion()
            }
        } else {
            Swal.fire(
                'No se puede procesar el pago!',
                'Favor revisar la distribución del pago. Restan:' +procesar,
                'warning'
            ) }
    }

    //Anular Facturas
    const AnularFactura = (e) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Anular esta factura",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                let response = fetch(Api + "VentasTrans/AnularFactura/"+ e.pedidoID);
                if (response.ok) {
                    let data =  response.json()
                    obtenerDatos(1)
                }
           
                Swal.fire(
                    'Se realizo la anulacion!',
                    '' ,
                    'success'
                )
              
                 
            }
        })

    }
    //Anular Facturas
    const ReasignarNcf = (e) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Anular esta factura",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                let response = fetch(Api + "VentasTrans/AnularFactura/"+ e.pedidoID);
                if (response.ok) {
                    let data =  response.json()
                    obtenerDatos(1)
                }
           
                Swal.fire(
                    'Se realizo la anulacion!',
                    '' ,
                    'success'
                )
              
                 
            }
        })

    }
                 
    //EliminarITBS 
    const EliminarITBS = () => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Eliminar ITBS",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                let response = fetch(Api + "VentasTrans/EliminarITBS/" + tabla.pedidoID);
                if (response.ok) {
                    let data = response.json()
                    TotalITBIS = 0;
                }

                Swal.fire(
                    'Se realizo la eliminacion!',
                    '',
                    'success'
                )
  obtenerDatosLineas(tabla.pedidoID)

            }
        })

    }

    //Lista de facturas
    const columns = [
        {
            width: '7%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus != 0 } color="warning" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>{row.estatuss}
                    <Button hidden={row.estatus == 0} color="primary" size="sm" className="mr-2"
                        target="_blank" href={"/ImpresionFactura/" + row.pedidoID}
                    >
                        {/*ImpresionFactura*/}
                        <i className="fas fa-print"></i>
                    </Button>
                </>
            ),
        },
       
        {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
            width: '35%',
            style: {
                fontSize: "10px",
            },
           
        },  {
            name: 'Total',
            selector: row => (toMoney(row.totalPago)),//.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            sortable: true,
            width: '15%',
            style: {
                fontSize: "10px",
            },


        },  {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
            width: '15%',
        }, {
            name: 'Fecha',
            selector: row => ( moment(row.fecha).format("DD/MM/YYYY") ),
            sortable: true,
            width: '20%',
        },
        {
            width: '5%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus != 1} color="danger" size="sm" className="mr-2"
                        onClick={() => ReasignarNcf(row)}
                    >
                        <i className="fas fa-loop">R</i>
                    </Button>

                    <Button hidden={row.estatus != 1} color="danger" size="sm" className="mr-2"
                        onClick={() => AnularFactura(row)}
                    >
                        <i className="fas fa-X">X</i>
                    </Button>
                   
                </>
            ),
        },

       
    ];
    //Lista de facturas
    const columnsC = [
        {
            width: '7%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus != 0} color="warning" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>{row.estatuss}
                    <Button hidden={row.estatus == 0} color="primary" size="sm" className="mr-2"
                        target="_blank" href={"/ImpresionCotizacion/" + row.pedidoID}
                    >
                        {/*ImpresionFactura*/}
                        <i className="fas fa-print"></i>
                    </Button>
                </>
            ),
        },

        {
            name: 'No. Cot',
            selector: row => row.facturaID,
            sortable: true,
            width: '15%',
            style: {
                fontSize: "10px",
            },
        },      {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
            width: '35%',
            style: {
                fontSize: "10px",
            },
        },
        {
            name: 'Total',
            selector: row => (toMoney(row.totalPago)),//.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            sortable: true,
            width: '15%',
            style: {
                fontSize: "10px",
            },


        }, {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
            width: '15%',
        }, {
            name: 'Fecha',
            selector: row => (moment(row.fecha).format("DD/MM/YYYY")),
            sortable: true,
            width: '20%',
        },
       

    ];
    //alert(isMobile)

    //Tabla lineas
const columns1 = [
    {

            name: 'Art.ID',
        selector: row => (<>

            <Button size="sm" hidden={row.editando } color="warning"
                onClick={() => EditarLinea1(row, true, 'editando', row.pedidoLineaID)}
            > <i className="fas fa-pen-alt"></i></Button>
            <Button size="sm" hidden={!row.editando}  color="success"
                onClick={() => EditarLinea(row, false, 'descripcion', row.pedidoLineaID)}
        > <i className="fas fa-save"></i></Button>
            <i hidden={isMobile }>  {row.articuloID} </i></>),
        sortable: true,
      
        style: {
            marginLeft: '0px',
            marginRight: '-60px',

        },
    },
    {
        name: 'Codigo',
        selector: row => (row.codigoAuxiliar),
        sortable: true,
        omit: isMobile,
        style: {
            marginLeft: '1px',
            marginRight: '1px',

        },
    },
    {
        name: 'Descripcion',
        selector: row => (row.editando ? (
            < Input value={row.descripcionArticulo} onChange={(e) => EditarLinea1(row, e.target.value, 'descripcion', row.pedidoLineaID)} style={{ width: "100%" }} ></Input>) : row.descripcionArticulo),
            sortable: true,
        width: "35%",
             style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },  {
            name: 'Cantidad',
        selector: row => (row.editando ? (
            < Input type="number" value={row.cantidad} onChange={(e) => EditarLinea1(row, e.target.value, 'cantidad', row.pedidoLineaID)}  ></Input>) : row.cantidad),
            sortable: true,
        style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },{
            name: 'Precio',
        selector: row => (row.editando ? (
            < Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'precio', row.pedidoLineaID)} value={row.precio}></Input>) : row.precio),
            sortable: true,
        style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },{
            name: 'Descuento',
        selector: row => (row.editando ? (
            < Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'descuento', row.pedidoLineaID)} value={row.descuento}></Input>) : row.descuento),
            sortable: true,
        width: "10%",
        omit: isMobile,
        style: {
            marginLeft: '1px',
            marginRight: '1px',

        },
    }
    //, {
    //        name: 'Pr. Sin ITBIS',
    //    selector: row => (toMoney(row.precioSinITBIS)),//.toFixed(2)(row.itbis.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
    //        sortable: true,
    //        width: "10%",
    //}, {
    //    name: 'ITBIS',
    //    selector: row => (toMoney(row.itbis)),//(row.itbis.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
    //        sortable: true,
            
    //}
    , {
            name: 'Total',
        selector: row => ((toMoney(row.totalLinea ) )),
            sortable: true,
        width: "",
        style: {
            marginLeft: '1px',
            marginRight: '-22px',

        },
        },

    
        {
            name: '',
            cell: row => (
                <>
                    <Button hidden={tabla.estatus>=1} size="sm" color="danger"
                        onClick={() => quitarArticulo(row.pedidoLineaID)}
                    >X</Button>
                </>
            ),
            
            style: {
                marginLeft: '1px',
                marginRight: '1px',

            },
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingRight: '1px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                minHeight: '30px',    
            }
        },
           Cell: {
            style: {
                backgroundColor: "#eee",
                   minHeight: '30px',
                   color: '#fff',
                   padding: "2px",
             
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    
    if (migrado != null && verModal == false  )  {
        
        NumeroUnico();
        obtenerDatosSN();
        obtenerDatosArticulas()
        obtenerDatosEmpresa()
        tabla.clienteID = 1
        tabla.telefono = migrado[0].telefono;
        tabla.nombreCliente = migrado[0].nombrePaciente;
        setVerModal(true);
    }
    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    const [isOpen, setIsOpen] = useState(false)
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }

    const onChangeArt = async (e) => {
        obtenerDatosArticulas(e.target.value)
        var l = ListadoArticulo;
        setbusqueda(e.target.value);
        var searchData = l.filter((item) => {
            if (
                (item.codigoAuxiliar + item.nombre)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListadoArticuloB(searchData);
    };
   
    const MensajeG = (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });

  
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            ArtEnter(inputValue)  
           
        }
    };
    const ArtEnter = async(e)  => {
        options2 = [];
        let response1 = await fetch(Api + "VentasMantenimiento/listaArticulosVB/" + e);
        if (response1.ok) {
            let data = await response1.json()
            if (data.length > 0) {
                data.filter(x => x.activo == true).map(x => {
                    options2.push({
                        value: x.articuloID, label: x.codigoAuxiliar + "-" + x.descripcion + "      -||              $" + x.precioPromedio, nombre: x.descripcion,
                        almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                        , cambiarPrecio: x.cambiarPrecio, itbisIncluido: x.itbisIncluido, codigoAuxiliar: x.codigoAuxiliar
                    })
                })
                inputRef.current.focus();
                handleChange3(options2[0])
            } else {
                Swal.fire(
                    'Revise el codigo!',
                    'no se encontro',
                    'warning'
                )
            }
        }
            
        
    }
    const [menuPosition, setMenuPosition] = useState(false);
 
    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition({
            x: event.pageX ,
            y: event.pageY ,
        });
    };

    const handleCloseMenu = () => {
        setMenuPosition(false);
    };
    const CerrarMantenimientos = () => {
        obtenerDatosClientes()
        obtenerDatosArticulas();
        setVerModalCliente(false);
        setVerModalArticulos(false);
    };


    const Asignarvalor = (p) => {

        switch (p) {
            case "CR":
                return setTabla2({ ...tabla2, credito: Total, efectivo: 0, transferencia: 0, cheque: 0, tarjeta: 0, formaPago:"CREDITO" });
            case "TR":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: Total, cheque: 0, tarjeta: 0, formaPago: "TRANSFERENCIA" });
            case "CH":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: 0, cheque: Total, tarjeta: 0, formaPago: "CHEQUE" });
            case "TA":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: 0, cheque: 0, tarjeta: Total, formaPago: "TARJETA" });
            default:
                return setTabla2({ ...tabla2, credito: 0, efectivo: Total, transferencia: 0, cheque: 0, tarjeta: 0, formaPago: "EFECTIVO" });

        }

    }

    return (
        <>

           

            <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel" style={{ width: "40%" }}>
                <div class="offcanvas-header">
                    <h5 id="offcanvasTopLabel">Busqueda del articulo</h5>
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body" style={{ padding: "1px" }}>
                    <div>
                      

                    <Input type="search" name="busquedaart" onChange={(e) => onChangeArt(e)} placeholder="Buscar  " ></Input> 

                        <table  style={{ textAlignLast: "left" }}>
                        <tr>
<th>Agregar</th>
 <th className="movilOcultar" >Codigo</th>
<th>Disp</th>
<th>Nombre</th>
<th>Precio</th>

                        </tr>
                        {ListadoArticuloB.map(x => (<tr>
                            <td>   {(parseFloat(ListadoDisponible.filter(a => a.articuloID == x.value && a.almacenID == x.almacenID).map(x => x.cantidad)).toFixed(2) > 0.00 || x.tipoArticulo == 1 ) && <Button size="sm" color="primary"
                                onClick={() => handleChange3(x)}
                            >{"< ADD"}</Button>}
                            </td>
                            <td className="movilOcultar">{x.codigoAuxiliar  }</td>
                            <td > {(x.tipoArticulo == 1)?"SEV": parseFloat(ListadoDisponible.filter(a => a.articuloID == x.value && a.almacenID == x.almacenID).map(x => x.cantidad)).toFixed(2)}</td>
                            <td>{x.nombre }</td>
                            <td>{toMoney(x.precio)}</td>
                        </tr>))}
                    </table>
                </div>

                </div>
            </div>
           
            <div onContextMenu={handleContextMenu}   >
                {/*Haz clic derecho en cualquier lugar.*/}
               
           

            <Card>
                <CardHeader style={{
                    backgroundColor: '#4e73df', color: "white", display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "0px",
    paddingTop: "0px"}}>
                    Lista de Pedidos
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                    </a>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={4}>

                                <Button color="success" size="sm" onClick={() => setverModalEditLinea(true)}
                                    title="Reimprime factura, cotizaciones y trae facturas pendientes"
                                >REIMPRIMIR FACTURA</Button>
                        </Col>
                        <Col md={2}>     <Button color="secundary" size="sm"
                            onClick={() => setVerModalCliente(true)}
                        >Crear Cliente</Button>
                        </Col>  <Col md={2}>     <Button color="secundary" size="sm"
                            onClick={() => setVerModalArticulos(true)}
                        >Crear Articulos</Button>
                        </Col>
                      

                    </Row>
                    <hr></hr>

                    {/*Facturacion*/ }
                    <Row>
                    <Col md="12" style={{ backgroundColor: "#f4f4f4",padding: "2px"} }>
                                <Row>
                                    <Col md={1}>
                                        <Label>Clientes re</Label>
                                    <Button onClick={() => setSeleccionCliente(!SeleccionCliente) } placehorder="Seleccionar Cliente registrado"><i className="fas fa-user"></i></Button>
                                    </Col>    <Col md={3}>  {(SeleccionCliente)?<FormGroup>

                                             <Label>* Cliente</Label>

                                            <Select
                                                name={"clienteID"}
                                                onChange={handleChange2}
                                                value={options.filter(x => x.value == tabla.clienteID).map(x => x)}
                                                options={options}
                                                isDisabled={tabla.pedidoID}
                                            />
                                        </FormGroup>     :
                                            <FormGroup>
                                    <Label>Nombre Cliente</Label>
                                            <Input disabled={tabla.clienteID != 1 || tabla.pedidoID} bsSize="sm" name="nombreCliente" onChange={handleChange} value={tabla.nombreCliente} />
                                          
                                            </FormGroup>  }
                                    </Col>
                                    
                                <Col md={2} >
                                    <FormGroup>

                                        <Label>RNC</Label>
                                            <Input disabled={tabla.clienteID != 1 || tabla.pedidoID} bsSize="sm" maxLength="11" name="rnc" onChange={handleChange} value={tabla.rnc} />
                                    </FormGroup></Col>
                                <Col md={2} >
                                    <FormGroup>

                                        <Label>Telefono</Label>
                                            <Input disabled={tabla.pedidoID } bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                                    </FormGroup></Col>
                    

                               
                           
                            <Col md={4}>
                                <FormGroup>

                                    <Label>Direccion</Label>
                                            <Input disabled={tabla.pedidoID} bsSize="sm" name="direccionEnvia" onChange={handleChange} value={tabla.direccionEnvia} />
                                </FormGroup></Col>
                                    <Col md={3} disabled={tabla.pedidoID}  >
                                <FormGroup>

                                    <Label style={{ color: "red" }}>Tipo NCF</Label>
                                            <Input disabled={tabla.pedidoID}  className="form-control" bsSize="sm" type={"select"} name="tipoComprobante" onChange={handleChange} value={tabla.tipoComprobante} >
                                        {
                                            SN.map((item) => (<option key={item.secuenciaID} value={item.secuenciaID}>{item.descripcion}</option>))
                                        }

                                    </Input>
                                        </FormGroup></Col>
                                    <Col md={1} disabled={tabla.pedidoID}  >
                                <FormGroup>

                                    <Label style={{ color: "red" }}>Moneda</Label>
                                            <Input disabled={tabla.pedidoID} className="form-control" bsSize="sm" type={"select"} name="moneda" onChange={handleChange} value={tabla.moneda} >
                                       <option value={"RD"}>RD</option>
                                       <option value={"USD"}>USD</option>
                                       <option value={"EUR"}>EUR</option>
                                       

                                    </Input>
                                </FormGroup></Col>
                            <Col hidden md={3} >
                                <FormGroup>

                                    <Label>NCF</Label>
                                    <Input bsSize="sm" name="ncf" onChange={handleChange} value={tabla.ncf} />
                                </FormGroup></Col>

                           

                            {/*<Col md={3} >*/}
                            {/*    <FormGroup>*/}

                            {/*        <Label>Fecha</Label>*/}
                            {/*        <Input bsSize="sm" type="date" name="fecha" onChange={handleChange} value={Moment(tabla.fecha).format('YYYY-MM-DD')} />*/}
                            {/*    </FormGroup></Col>*/}

                            <Col md={4} >
                                <FormGroup>

                                    <Label>Comentario</Label>
                                            <Input disabled={tabla.pedidoID}  bsSize="sm" rows="1" type="textarea"  name="comentario" onChange={handleChange} value={tabla.comentario} />
                                </FormGroup></Col>
                                
                        </Row>
                            
                            
                            <div hidden={!tabla.nombreCliente} style={{background: "#d2ddfc",
                                color: "black"
} } >
                                <div style={{ border: "1px solid #191aa652" }}></div>

                                <Button  size="sm" color="primary" class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" >Agregar Articulo</Button>
                                <input 
                                    type="text"
                                    value={inputValue}
                                    ref={inputRef} 
                                    onChange={handleInputChange}
                                    onKeyPress={handleKeyPress} // Agrega el evento onKeyPress
                                    placeholder="Escribe Codigo y Enter"
                                />
                                <div hidden>
                                    <Row>
                                    <Col md={1} > <Label>Buscador de Servicio</Label></Col>
                                <Col md={8} >
                                    <Select
                                        name={"articuloID"}
                                        onChange={handleChange3}
                                                options={options1}
                                               
                                            /></Col>
                                        </Row>
</div>
                                <Row hidden> {/*style={{ justifyContent: "space-around", alignItems: "left" }}>*/}
                                    <Col md={1} hidden={!tabla1.articuloID}>Servicio</Col>
                                    <Col md={6} hidden={!tabla1.articuloID}>
                                        
                                        <Input bsSize="sm" type="text" name="descripcionArticulo" onChange={handleChange4} value={tabla1.descripcionArticulo} />
                                     
                                    </Col>
                                    <Col md={0.5} >

                                        {ListadoDisponible.filter(x => x.articuloID == tabla1.articuloID).map(x => x.cantidad)}
                                    </Col>
                                        <Col md={0.5} hidden={!tabla1.articuloID}>
                                        RD$:</Col>
   <Col md={2} hidden={!tabla1.articuloID}>
                                        
                                            <Input bsSize="sm" type="number" name="precio" onChange={handleChange4} value={tabla1.precio} />
                                     
                                    </Col>
                                    <Col md={1} >
                                        <Button hidden={!tabla1.articuloID } size="sm" color="primary" 
                                            onClick={guardarCambios} 
                                    >Agregar</Button>
                                </Col>
                            </Row>
                                <Row>
                                  
                                        <DataTable
                                    columns={columns1}
                                    data={ListadoLineas}
                                    //progressPending={pendiente1}
                                    //  pagination
                                    //    paginationComponentOptions={paginationComponentOptions}
                                    customStyles={customStyles}
                                />
                                      
                                   
                               
                                </Row>
                                <Row style={{ justifyContent: "space-around",   alignItems: "center"} }>
                                <div hidden={tabla.pedidoID == 0}>
                                    Sub Total: <b>${SubTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>     Total Descuento: <b>${TotalDescuento.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>  Total ITBIS: <b>${TotalITBIS.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>  Total A Pagar: <b>${Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>
                                </div>
                                {/*<Button hidden={tabla.pedidoID != 0 && tabla.estatus == 1} size="sm" color="primary"*/}
                                {/*    onClick={()=>EnviarCaja(tabla.pedidoID)}*/}
                                {/*>Enviar a Caja</Button>   */}
                                </Row>
                                <div class="box">

   <Button size="sm" color="danger"
                                    onClick={cerrarModal} title="Reinicia todo los campos para generar una factura nueva"
                                    >Limpiar</Button>
                                    <div hidden={V_Procesar} >
                                        <Button hidden={tabla.facturado} size="sm" color="secundary"
                                            onClick={() => ProcesarCotizacion()}
                                        >Cotizar {tabla.facturado}</Button></div>

                                    <div hidden={tabla.tipoComprobante == 3}>    <div hidden={ListadoLineas.length == 0}>
                                    <div hidden={V_Procesar} >                       <Button hidden={tabla.pedidoID == 0} size="sm" color="success"
                                        onClick={() => setVerModalPago(true)}
                                    >Procesar pago</Button></div></div></div>
                                {/*<div hidden={tabla.tipoComprobante != 3} >*/}
                                   

                             
                             
                           </div>  
                        </div>

                    </Col>
                    {/*Listado*/ }
                    <Col md="4" >
                   
                        </Col>
                    </Row>
                </CardBody>
            </Card>
                {menuPosition && (
                    <ul
                        style={{
                            position: 'absolute',
                            top: menuPosition.y,
                            left: menuPosition.x,
                            backgroundColor: 'white',
                            border: '1px solid gray',
                            listStyle: 'none',
                            padding: '10px',
                            margin: 0,
                        }}
                        onClick={handleCloseMenu} // Cierra el menú al hacer clic.
                    >
                        <li>Opción Segundarias</li>
                        <li><a className="btn" onClick={() => SetmodalEditPedido(true)}> Editar Datos de Factura</a></li>
                        <li><a className="btn" onClick={() => EliminarITBS() }> Eliminar todos los ITBIS</a></li>
                       
                    </ul>
                )}
            </div>
     

            <Modal isOpen={verModalPago} >
                <ModalHeader className="modal-header1">
                    Cobrando a: {tabla.nombreCliente}
                </ModalHeader>
                <ModalBody>
                    <h3>  Monto a Pagar: <b> ${Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </h3>
                    <Col md={6} >
                        <FormGroup>

                            <Label>Efetivo</Label>
                            <div class="box">
                            <Input bsSize="sm" type="number" name="efectivo" onChange={handleChangeP} value={tabla2.efectivo} />
                            <Button size="sm" color="success" onClick={() => Asignarvalor("EF")} ><i className="fas fa-money-bill"></i></Button>
                                </div>
                        </FormGroup></Col>  <Col md={6} >
                        <FormGroup>

                            <Label>Credito</Label>
                            <div class="box">
                                <Input bsSize="sm" type="number" name="credito" onChange={handleChangeP} value={tabla2.credito} />
                                <Button size="sm" color="success" onClick={() => Asignarvalor("CR")}><i class="fas fa-comment-dollar"></i></Button>
                            </div>
                        </FormGroup></Col>
                    <Col md={6} >
                        <FormGroup>

                            <Label>Tarjeta</Label>
                            <div class="box">
                                <Input bsSize="sm" type="number" name="tarjeta" onChange={handleChangeP} value={tabla2.tarjeta} />
                                <Button size="sm" color="success" onClick={() => Asignarvalor("TA")}><i class="fa fa-credit-card"></i></Button>
                            </div>
                        </FormGroup></Col>
                    <Col md={6} >
                        <FormGroup>

                            <Label>Transferencia</Label>
                            <div class="box">
                                <Input bsSize="sm" type="number" name="transferencia" onChange={handleChangeP} value={tabla2.transferencia} />
                                <Button size="sm" color="success" onClick={() => Asignarvalor("TR")}><i class="fas fa-exchange-alt"></i></Button>
                            </div>
                        </FormGroup></Col>
                    <Col md={6} >
                        <FormGroup>

                            <Label>Cheque</Label>
                            <div class="box">
                                <Input bsSize="sm" name="cheque" onChange={handleChangeP} value={tabla2.cheque} />
                                <Button size="sm" color="success" onClick={() => Asignarvalor("CH")}><i class="fa fa-money-check"></i></Button>
                            </div>
                        </FormGroup></Col>
                    <h3> <b> Devuelta: ${((parseFloat((tabla2.efectivo)) + parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia) + parseFloat(tabla2.cheque)+parseFloat(tabla2.credito)) - Total).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") }
               </b></h3> </ModalBody>
                <ModalFooter>


                <div></div>
                    <Button hidden={tabla.facturado} size="sm" color="success" disabled={apagarpago}
                        onClick={() => ProcesarPago()}

                    >Pagar {tabla.facturado}</Button>
                    <Button size="sm" color="danger"
                        onClick={() => setVerModalPago(false)}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Mantenimiento Cliente*/}

            <Modal isOpen={verModalCliente} className="modal-preguntas" >
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Mantenimiento de Clientes </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerModalCliente(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
       <Clientes></Clientes>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => CerrarMantenimientos(false)}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

                {/*Mantenimiento Articulo*/}

            <Modal isOpen={verModalArticulos} className="modal-preguntas" >
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Mantenimiento de Articulos </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setVerModalArticulos(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
       <Articulos></Articulos>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => CerrarMantenimientos()}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

     
               {/*Mantenimiento Linea en vivo*/}

            <Modal isOpen={verModalEditLinea} className="modal-preguntas" >
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Historial de facturas  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setverModalEditLinea(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                   
                    <Tabs >
                        <TabList>
                            <Tab>Facturas</Tab>
                            <Tab>Cotizaciones</Tab>
                        </TabList>

                        <TabPanel>
                            <Col md={6}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  de factura" ></Input> </Col>
                            <br></br>
                            {/*Facturas*/}
                            <DataTable
                                columns={columns}
                                data={Listado}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                customStyles={customStyles}
                                expandableRows
                                expandableRowsComponent={VentasLineas}
                            />

                        </TabPanel>
                        <TabPanel>
                            {/*Facturas*/}
                            <DataTable
                                columns={columnsC}
                                data={ListadoCotizacion}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                customStyles={customStyles}
                                expandableRows
                                expandableRowsComponent={VentasLineas}
                            />
                        </TabPanel>
                    </Tabs>

                   
                   
                 
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => setverModalEditLinea(false)}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
            {/*FACT*/}
            <Modal className="modal-preguntas" isOpen={modalEditPedido}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> EDITAR PEDIDO  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => SetmodalEditPedido(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                                <Col md={4} >
                                    <FormGroup>

                                        <Label>Nombre Cliente</Label>
                                        <Input  bsSize="sm" name="nombreCliente" onChange={handleChange} value={tabla.nombreCliente} />
                                    </FormGroup></Col>
                                <Col md={2} >
                                    <FormGroup>

                                        <Label>RNC</Label>
                                        <Input bsSize="sm" maxLength="11" name="rnc" onChange={handleChange} value={tabla.rnc} />
                                    </FormGroup></Col>
                                <Col md={2} >
                                    <FormGroup>

                                        <Label>Telefono</Label>
                                        <Input  bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                                    </FormGroup></Col>
                                <Col md={4}>
                                    <FormGroup>

                                        <Label>* Cliente</Label>
                                        {/*<Input bsSize="sm" name="clienteID" onChange={handleChange} value={tabla.clienteID} />*/}

                                        <Select
                                            name={"clienteID"}
                                            onChange={handleChange2}
                                            value={options.filter(x => x.value == tabla.clienteID).map(x => x)}
                                            options={options}
                                            is
                                        />
                                    </FormGroup></Col>



                                <Col md={4}>
                                    <FormGroup>

                                        <Label>Direccion</Label>
                                        <Input  bsSize="sm" name="direccionEnvia" onChange={handleChange} value={tabla.direccionEnvia} />
                                    </FormGroup></Col>
                                <Col md={3}   >
                                    <FormGroup>

                                        <Label style={{ color: "red" }}>Tipo NCF</Label>
                                        <Input  className="form-control" bsSize="sm" type={"select"} name="tipoComprobante" onChange={handleChange} value={tabla.tipoComprobante} >
                                            {
                                                SN.map((item) => (<option key={item.secuenciaID} value={item.secuenciaID}>{item.descripcion}</option>))
                                            }

                                        </Input>
                                    </FormGroup></Col>
                                <Col hidden md={3} >
                                    <FormGroup>

                                        <Label>NCF</Label>
                                        <Input bsSize="sm" name="ncf" onChange={handleChange} value={tabla.ncf} />
                                    </FormGroup></Col>

                        <Col md={1} disabled={tabla.pedidoID}  >
                            <FormGroup>

                                <Label style={{ color: "red" }}>Moneda</Label>
                                <Input  className="form-control" bsSize="sm" type={"select"} name="moneda" onChange={handleChange} value={tabla.moneda} >
                                    <option value={"RD"}>RD</option>
                                    <option value={"USD"}>USD</option>
                                    <option value={"EUR"}>EUR</option>


                                </Input>
                            </FormGroup></Col>

                                {/*<Col md={3} >*/}
                                {/*    <FormGroup>*/}

                                {/*        <Label>Fecha</Label>*/}
                                {/*        <Input bsSize="sm" type="date" name="fecha" onChange={handleChange} value={Moment(tabla.fecha).format('YYYY-MM-DD')} />*/}
                                {/*    </FormGroup></Col>*/}

                                <Col md={4} >
                                    <FormGroup>

                                        <Label>Comentario</Label>
                                        <Input  bsSize="sm" rows="1" type="textarea" name="comentario" onChange={handleChange} value={tabla.comentario} />
                                    </FormGroup></Col>
                            </Row>

                 
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="success"
                        onClick={() => guardarCambios()}

                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={() => SetmodalEditPedido(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Ventas.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

        
        </>
    )

}
//export default Venta;